import EmojiPicker from './EmojiPicker';

export default EmojiPicker;
